import Vue from 'vue';
import VueX from 'vuex';

import initialState from './store/_initialState';
import mutations from './store/_mutations';
import actions from './store/_actions';
import getters from './store/_getters';

Vue.use(VueX);

const store = new VueX.Store({
	state: initialState,
	mutations,
	actions,
	getters
});

export default store;